import * as React from "react";
function SvgTagGeomark(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M15 32.1H3.3L1 20.4 16.9.7l14.5 11.7-2.7 3.3-1.5-1.3 1.3-1.7-11.3-9.2L3.1 21l1.8 9.1H15v2zm-5.2-9.5c.6 0 1 .5 1 1s-.5 1-1 1-1-.5-1-1 .5-1 1-1m0-2c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zM20.2 14c-3.3 0-6 2.7-6 6s6 12 6 12 6-8.7 6-12-2.7-6-6-6zm.1 8.5c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4 2.4 1.1 2.4 2.4c0 1.3-1.1 2.4-2.4 2.4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTagGeomark);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
